import A from './agreeableness';
import C from './conscientiousness';
import E from './extraversion';
import N from './neuroticism';
import O from './openness_to_experience';

export default Object.assign([], [A, E, N, C, O]);
